// Direct port of the design's `Accordion`. Phase 2b CSS supplies the
// `.acc-*` classes already; this component only owns the open state and
// the chev rotation.

import { useState, type JSX, type ReactNode } from "react";

import { Icon, type IconName } from "./Icon";

interface AccordionProps {
  readonly icon: IconName;
  readonly title: string;
  readonly count?: string | number;
  readonly defaultOpen?: boolean;
  readonly onOpenChange?: (open: boolean) => void;
  readonly children: ReactNode;
}

export const Accordion = ({
  icon,
  title,
  count,
  defaultOpen = false,
  onOpenChange,
  children,
}: AccordionProps): JSX.Element => {
  const [open, setOpen] = useState(defaultOpen);
  const toggle = (): void => {
    setOpen((o) => {
      const next = !o;
      onOpenChange?.(next);
      return next;
    });
  };
  return (
    <div className={`acc ${open ? "open" : ""}`}>
      <button type="button" className="acc-head" onClick={toggle}>
        <span className="acc-icon">
          <Icon name={icon} size={14} />
        </span>
        <span className="acc-title">{title}</span>
        {count !== undefined && <span className="acc-count">{count}</span>}
        <span className="acc-chev">
          <Icon name="chevron-down" size={15} />
        </span>
      </button>
      {open && <div className="acc-body">{children}</div>}
    </div>
  );
};
